import { type UseQueryResult } from '@tanstack/react-query';
import { type Row, type RowData } from '@tanstack/react-table';

const getRawColumnValue = (row: RowData, columnId: string): unknown =>
  columnId.split('.').reduce<unknown>((value, key) => {
    if (typeof value !== 'object' || value === null) {
      return undefined;
    }

    return Reflect.get(value, key);
  }, row);

export const defaultColumnFilterFn = <T extends RowData>(
  row: Row<T>,
  columnId: string,
  filterValue: unknown
): boolean => getRawColumnValue(row.original, columnId) === filterValue;

/**
 * True while a query has nothing valid to show for its current key: first load, or the previous
 * key's data kept as a placeholder. A background refetch of data already shown is not included.
 */
export const isLoadingNewData = (
  query: Pick<UseQueryResult, 'isLoading' | 'isPlaceholderData'>
): boolean => query.isLoading || query.isPlaceholderData;
